import { helper as buildHelper } from '@ember/component/helper';

export function setHas(params/*, hash*/) {
  let set = params[0];
  let item = params[1];

  // This is an optional tracking set in case you're iterating over a group of items and
  // want to have a resultant collection of items that were found in the set.
  let trackingSet = params[2];

  // Allow arrays to be passed (obviously not optimal, but useful in a pinch)
  set = Array.isArray(set) ? new Set(set) : set;

  if(set.has(item)){
    if(trackingSet) {
      trackingSet.add(item);
    }
    return true;
  }
  return false;

}

export default buildHelper(setHas);
